import dynamic from 'next/dynamic';
import { GameSectionsSkeleton } from '@/widgets/game-sections/ui/game-sections-skeleton';

export const DynamicGameSections = dynamic(
  () => import('./game-sections').then(m => m.GameSections),
  {
    ssr: false,
    loading: () => <GameSectionsSkeleton />
  }
)